import { render, staticRenderFns } from "./Assessment-Listing-Template.vue?vue&type=template&id=214c6e9f"
import script from "./Assessment-Listing-Template.vue?vue&type=script&lang=js"
export * from "./Assessment-Listing-Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports